<div class="pp">

  <!-- The product first: Chrome windows fanned out, each in another of its themes, on the
       stage; its store pictures under Screenshots. -->
  <div class="pp-stage">
    <header class="pp-wrap pp-intro">
      <div class="pp-intro-main">
        <span class="pp-platform">
          <img src="./assets/third-parties/logo/chrome.webp" alt="">
          Chrome Extension
        </span>
        <h1 class="pp-name">
          <img src="./assets/product-lines/tools/all-in-one-themes.png" alt="" class="pp-icon" width="72" height="72">
          <span>All In One Themes</span>
        </h1>
        <p class="pp-pitch">Browse and apply Codigrate's Chrome themes inspired by nature and iconic cities, all from one popup</p>
        <ul class="pp-facts" aria-label="At a glance">
          <li *ngFor="let f of facts">{{ f }}</li>
        </ul>
      </div>

      <div class="pp-act">
        <div class="pp-cta">
          <a class="codigrate-button" [href]="storeUrl" target="_blank" rel="noopener" (click)="onInstall()"><p>Install from Chrome</p></a>
          <a class="codigrate-button cp-btn-neutral" routerLink="/themes"><p>Browse Themes</p></a>
        </div>
      </div>
    </header>

    <div class="pp-wrap">
      <figure class="pp-shot" [class.pp-shot-panel]="hero.kind === 'panel'" [class.pp-shot-wide]="hero.kind === 'wide'">
        <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
      </figure>
    </div>
  </div>

  <div class="pp-wrap">

    <section class="pp-highlights" aria-label="Highlights">
      <div class="pp-highlight" *ngFor="let f of highlights">
        <h2>{{ f.title }}</h2>
        <p>{{ f.description }}</p>
      </div>
    </section>

    <section class="pp-section" *ngIf="screenshots.length">
      <h2 class="pp-section-title">Screenshots</h2>
      <div class="pp-gallery">
        <figure class="pp-figure" *ngFor="let s of screenshots">
          <button class="pp-shot" type="button" (click)="openLightbox( s )" [attr.aria-label]="'Enlarge ' + s.name">
            <img [src]="s.src" [alt]="s.alt" width="1600" height="1000" loading="lazy" decoding="async">
          </button>
          <figcaption>{{ s.name }}</figcaption>
        </figure>
      </div>
    </section>

    <section class="pp-section" *ngIf="chromeThemes.length">
      <h2 class="pp-section-title">Themes Inside</h2>
      <div class="cp-theme-grid">
        <div class="cp-theme-card" *ngFor="let t of chromeThemes">
          <button class="cp-theme-shot" type="button" (click)="openTheme( t )"
                  [attr.aria-label]="'Enlarge ' + t.name + ' screenshot'">
            <img [src]="t.screenshot" [alt]="t.name + ' Chrome theme'" loading="lazy" decoding="async">
          </button>
          <span class="cp-theme-name">
            <img class="cp-theme-logo" [src]="t.logo" alt="" loading="lazy" decoding="async">
            {{ t.name }}
          </span>
        </div>
      </div>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">What Else You Get</h2>
      <ul class="pp-list">
        <li *ngFor="let f of more">
          <h3>{{ f.title }}</h3>
          <p>{{ f.description }}</p>
        </li>
      </ul>
    </section>

    <!-- The picked theme's screenshot enlarged: the same lightbox as the store pictures', with the
         theme's logo and name in the pill and Close beside them. -->
    <div class="cp-lightbox" *ngIf="lightboxTheme" role="dialog" aria-modal="true" [attr.aria-label]="lightboxTheme.name + ' Chrome theme'" (click)="closeTheme()">
      <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
        <img [src]="lightboxTheme.screenshot" [alt]="lightboxTheme.name + ' Chrome theme'">
      </figure>
      <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
        <span class="cp-lb-seg cp-lb-platform">
          <span class="cp-lightbox-logo-circle"><img class="cp-lightbox-logo" [src]="lightboxTheme.logo" alt=""></span>
          {{ lightboxTheme.name }}
        </span>
        <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeTheme()" aria-label="Close">&times;</button>
      </div>
    </div>

    <!-- The store pictures' lightbox: the theme pages' (src/styles/page/tool-lightbox.scss). The picture over a
         frosted backdrop and one pill under it: previous, the picture's name, next, close.
         The arrow keys page through the pictures and Escape closes. -->
    <div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
      <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
        <img [src]="lightbox.large" [alt]="lightbox.alt">
      </figure>
      <ng-container *ngIf="shots.length > 1">
        <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
        <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
      </ng-container>
      <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
        <button class="cp-lb-seg cp-lb-nav" type="button" *ngIf="shots.length > 1" (click)="stepLightbox( -1, $event )" aria-label="Previous screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <span class="cp-lb-seg td-lb-label">
          <span class="cp-lb-name">
            <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
            <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
          </span>
        </span>
        <button class="cp-lb-seg cp-lb-nav" type="button" *ngIf="shots.length > 1" (click)="stepLightbox( 1, $event )" aria-label="Next screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
      </div>
    </div>

    <section class="cp-closing">
      <h2 class="cp-closing-title">Pick Your Theme</h2>
      <p class="cp-closing-text">Add it to Chrome and your whole browser changes its mood</p>
      <a class="codigrate-button cp-closing-btn" [href]="storeUrl" target="_blank" rel="noopener" (click)="onInstall()"><p>Install from Chrome</p></a>
    </section>

  </div>

</div>
